import { c as _c } from "react/compiler-runtime";
import StrapiImage, { StrapiImageProps } from "@components/StrapiImage";
import { ComponentBlocksImage } from "@lib/generated/graphql";
import clsx from "clsx";
import { FC } from "react";
interface ImageProps {
  image: ComponentBlocksImage | null;
  roundedClass?: string;
}
const ImageBlock: FC<ImageProps & Omit<StrapiImageProps, "image">> = t0 => {
  const $ = _c(34);
  let className;
  let image;
  let props;
  let roundedClass;
  let width;
  if ($[0] !== t0) {
    ({
      image,
      className,
      width,
      roundedClass,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = image;
    $[3] = props;
    $[4] = roundedClass;
    $[5] = width;
  } else {
    className = $[1];
    image = $[2];
    props = $[3];
    roundedClass = $[4];
    width = $[5];
  }
  if (!image) {
    return null;
  }
  const objectClass = `object-${image.fit} object-${image.position}`;
  const isContain = image.fit === "contain";
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[6] !== className || $[7] !== image.fit || $[8] !== image.image || $[9] !== image.position || $[10] !== image.style || $[11] !== isContain || $[12] !== objectClass || $[13] !== props || $[14] !== roundedClass || $[15] !== width) {
    const styles = image.style?.split("_");
    const imageClasses = [objectClass];
    if (styles?.includes("shadow")) {
      imageClasses.push("shadow-3");
    }
    if (styles?.includes("border")) {
      imageClasses.push("border border-neutral-50");
    }
    if (styles?.includes("rounded")) {
      imageClasses.push(roundedClass || "rounded-m");
    }
    if ($[22] !== image.position || $[23] !== isContain) {
      t5 = clsx("relative max-h-[50vh] m:max-h-full w-full h-full flex items-center justify-center", isContain && {
        "m:items-end m:justify-center": image.position === "bottom",
        "m:items-end m:justify-end": image.position === "bottom_right",
        "m:items-end m:justify-start": image.position === "bottom_left",
        "m:items-start m:justify-center": image.position === "top",
        "m:items-start m:justify-end": image.position === "top_right",
        "m:items-start m:justify-start": image.position === "top_left",
        "m:justify-end m:items-center": image.position === "right",
        "m:justify-start m:items-center": image.position === "left"
      });
      $[22] = image.position;
      $[23] = isContain;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    T0 = StrapiImage;
    t1 = props;
    t2 = width;
    t3 = image.image;
    t4 = clsx("max-w-full max-h-[50vh] m:max-h-full", className, ...imageClasses, {
      "h-full w-full": image.fit === "cover"
    });
    $[6] = className;
    $[7] = image.fit;
    $[8] = image.image;
    $[9] = image.position;
    $[10] = image.style;
    $[11] = isContain;
    $[12] = objectClass;
    $[13] = props;
    $[14] = roundedClass;
    $[15] = width;
    $[16] = T0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    T0 = $[16];
    t1 = $[17];
    t2 = $[18];
    t3 = $[19];
    t4 = $[20];
    t5 = $[21];
  }
  let t6;
  if ($[25] !== T0 || $[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t4) {
    t6 = <T0 {...t1} width={t2} image={t3} className={t4} />;
    $[25] = T0;
    $[26] = t1;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== t5 || $[32] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  return t7;
};
export default ImageBlock;